import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loading = new BehaviorSubject<boolean>(false);
  public loading$ = this.loading.asObservable();
  private previousUrl = new BehaviorSubject<string | null>(null);
  public previousUrl$ = this.previousUrl.asObservable();

  buttonLoader: EventEmitter<boolean> = new EventEmitter(false);
  buttonLoaderTimer: number;

  constructor() {
    this.buttonLoaderTimer = environment.buttonLoaderMinTime; // milli second
  }
  loadingStart = () => setTimeout(() => this.loading.next(true));

  loadingClose = () => setTimeout(() => this.loading.next(false), 100);

  setPreviousUrl = (previousUrl: string) => this.previousUrl.next(previousUrl);

  public buttonLoaderTrue() {
    this.buttonLoaderTimer = environment.buttonLoaderMinTime;
    this.buttonLoader.next(true);
    const interval = setInterval(() => {
      this.buttonLoaderTimer = this.buttonLoaderTimer - 1000;
      if (this.buttonLoaderTimer <= 0) {
        clearInterval(interval);
        this.buttonLoader.next(false);
      }
    }, 1000);
  }
  public buttonLoaderFalse() {
    if (this.buttonLoaderTimer <= 0) {
      this.buttonLoaderTimer = 0;
      this.buttonLoader.next(false);
    }
  }
}
